import { FC } from 'react';
import { BrgButton, ButtonVariant, Colors, FInter, FlexBox, useIsMobile } from '@brg/ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LayoutConst, useModal } from 'core';
import { ReactComponent as CloseIcon } from 'shared/assets/32/close_icon_modal.svg';
import ClickAwayListener from 'shared/pages/ChildrensBooks/components/ui/ClickAwayListener';

export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;

const OuterWrapper = styled(FlexBox)`
  position: fixed;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(21, 21, 20, 0.60);
  backdrop-filter: blur(10px);
  z-index: 9999999999;
`;

const Wrapper = styled(ClickAwayListener)`
  background-color: ${({ theme }) => theme.ageModal.bg};
  display: flex;
  width: 560px;
  padding: 24px 32px 32px 32px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  border-radius: 8px;

  svg {
    flex-shrink: 0;
    cursor: pointer;
  }


  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 480px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 20px;
    line-height: 25px;
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    width: 100%;
    border-radius: 8px 8px 0 0 ;
    position: fixed;
    bottom: 0;
  }
`;

const Title = styled(FInter.SectionTitle) <{ isMobile: boolean }>`
  
  letter-spacing: -0.6px;
  margin-bottom: 8px;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 29px; /* 126.087% */
    letter-spacing: -0.46px;
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
   
  }

  color: ${({ theme }) => theme.not_saved_modal.title};
`

const Description = styled(FInter.SectionTitle) <{ isMobile: boolean, align?: string }>`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 123.077% */
  }
  
  color: ${({ theme }) => theme.not_saved_modal.title};
  text-align: ${({ align }) => align || 'initial'};
`

export const SelectLabel = styled.label`
  margin: 0 15px 8px 0;

  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  color: ${Colors.galBlack47};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 123.077% */
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-left: 0;
  }
`;

const ButtonWrapper = styled(FlexBox)`
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
  gap: 16px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
    margin-top: 16px;
    gap: 8px;
  }
`;

const Button = styled(BrgButton)`
  flex: 1;
`;

export const SendConfirmation: FC<{ onConfirm: () => void, onCancel: () => void }> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const modal = useModal();
  const isMobile = useIsMobile();

  const handleClose = () => {
    modal.back();
  }

  return (
    <OuterWrapper>
      <Wrapper onClickAway={handleClose}>
        <FlexBox justify={'space-between'} width={'100%'} gx={16}>
          <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'flex-start'}
            justifyMobile='center'
            align={'flex-start'} alignMobile={'flex-start'}>

            <Title isMobile={isMobile}>
              {t('project_edit.send_confirmation')}
            </Title>
            <Description isMobile={isMobile}>
              {t('project_edit.send_confirmation_description')}
            </Description>
          </FlexBox>
          <CloseIcon onClick={handleClose} />
        </FlexBox>
        <ButtonWrapper offsetTop={8} width="100%"> 
          <Button variant={ButtonVariant.Hollow} onClick={onCancel}>
            {t('request_publication_modal.cancel')}
          </Button>
          <Button variant={ButtonVariant.Filled} onClick={onConfirm}>
            {t('request_publication_modal.confirm')}
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </OuterWrapper>
  )
};

export default SendConfirmation;import { FC } from 'react';
import { BrgButton, ButtonVariant, Colors, FInter, FlexBox, useIsMobile } from '@brg/ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { LayoutConst, useModal } from 'core';
import { ReactComponent as CloseIcon } from 'shared/assets/32/close_icon_modal.svg';
import ClickAwayListener from 'shared/pages/ChildrensBooks/components/ui/ClickAwayListener';

export const BackLink = styled(FInter.SectionTitleDiv)`
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.71;
  }
`;

const OuterWrapper = styled(FlexBox)`
  position: fixed;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: rgba(21, 21, 20, 0.60);
  backdrop-filter: blur(10px);
  z-index: 9999999999;
`;

const Wrapper = styled(ClickAwayListener)`
  background-color: ${({ theme }) => theme.ageModal.bg};
  display: flex;
  width: 560px;
  padding: 24px 32px 32px 32px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  border-radius: 8px;

  svg {
    flex-shrink: 0;
    cursor: pointer;
  }


  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 480px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 20px;
    line-height: 25px;
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    width: 100%;
    border-radius: 8px 8px 0 0 ;
    position: fixed;
    bottom: 0;
  }
`;

const Title = styled(FInter.SectionTitle) <{ isMobile: boolean }>`
  
  letter-spacing: -0.6px;
  margin-bottom: 8px;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 29px; /* 126.087% */
    letter-spacing: -0.46px;
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
   
  }

  color: ${({ theme }) => theme.not_saved_modal.title};
`

const Description = styled(FInter.SectionTitle) <{ isMobile: boolean, align?: string }>`
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  letter-spacing: -0.34px;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 123.077% */
  }
  
  color: ${({ theme }) => theme.not_saved_modal.title};
  text-align: ${({ align }) => align || 'initial'};
`

export const SelectLabel = styled.label`
  margin: 0 15px 8px 0;

  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 129.412% */
  color: ${Colors.galBlack47};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; /* 123.077% */
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    margin-left: 0;
  }
`;

const ButtonWrapper = styled(FlexBox)`
  justify-content: space-between;
  width: 100%;
  margin-top: 24px;
  gap: 16px;

  @media (max-width: ${LayoutConst.screen.s}px) {
    flex-direction: column;
    margin-top: 16px;
    gap: 8px;
  }
`;

const Button = styled(BrgButton)`
  flex: 1;
`;

export const SendConfirmation: FC<{ onConfirm: () => void, onCancel: () => void }> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const modal = useModal();
  const isMobile = useIsMobile();

  const handleClose = () => {
    modal.back();
  }

  return (
    <OuterWrapper>
      <Wrapper onClickAway={handleClose}>
        <FlexBox justify={'space-between'} width={'100%'} gx={16}>
          <FlexBox direction={'column'} directionMobile='column' width={'100%'} justify={'flex-start'}
            justifyMobile='center'
            align={'flex-start'} alignMobile={'flex-start'}>

            <Title isMobile={isMobile}>
              {t('project_edit.send_confirmation')}
            </Title>
            <Description isMobile={isMobile}>
              {t('project_edit.send_confirmation_description')}
            </Description>
          </FlexBox>
          <CloseIcon onClick={handleClose} />
        </FlexBox>
        <ButtonWrapper offsetTop={8} width="100%"> 
          <Button variant={ButtonVariant.Hollow} onClick={onCancel}>
            {t('request_publication_modal.cancel')}
          </Button>
          <Button variant={ButtonVariant.Filled} onClick={onConfirm}>
            {t('request_publication_modal.confirm')}
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </OuterWrapper>
  )
};

export default SendConfirmation;